import './attendance.less';
import * as _ from 'lodash';

AttendanceDialogController.$inject = [];
function AttendanceDialogController() {
    this.$onInit = function () {
        this.attendance = this._resolve.attendance;
        var candidates = this._resolve.missions;
        if (candidates == null || candidates.length === 0) {
            this.missions = null;
            this.selectedMission = null;
        } else {
            if (this.attendance.MissionId != null) {
                // Already specified, but not saved yet.
                this.selectedMission = _.find(candidates, x => x.Id === this.attendance.MissionId);
            } else {
                const attOrgId = this.attendance.OrganizationId || this.attendance.Meeting.OrganizationId;
                this.selectedMission = _.find(candidates, x => x.MissionTypeId === this.attendance.MissionTypeId && x.MandatePeriod.OrganizationId === attOrgId);
            }
            this.missions = _.sortBy(candidates, [x => x.MandatePeriod.Organization.Name, x => x.Start, x => x.End]);
        }
    };

    this.canSave = function () {
        return this.form && this.form.$valid && this.selectedMission != null;
    };

    this.save = function save() {
        if (!this.canSave()) return;
        this._close({ $value: this.selectedMission });
    };

    this.cancel = function () {
        this._dismiss();
    };
}

angular.module("tromanWeb").component("ergoAttendanceDialog", {
    template: require('./attendanceDialog.html'),
    bindings: {
        _close: '&close',
        _dismiss: '&dismiss',
        _resolve: '<resolve',
        _modal: '<modalInstance'
    },
    controller: AttendanceDialogController
});
